module.exports = __webpack_public_path__ + "images/category_lp/tablet/banner_c6244c26bfe96de1ed079b455fab68fc.png";